import { useEffect } from 'react'

import { loadHotjar } from '../vendor/hotjar'

export default function useHotjar() {
  useEffect(() => {
    // This creates window.hj in production.
    loadHotjar()
  }, [])
}
